export default "__VITE_ASSET__DcVvNyCK__"